import React, { useEffect, useState } from 'react'
import System from 'src/helper/system';
import QuoteDetail from '@system/config/quote';
import { QuoteDetailSearchFilter } from './DetailFilter/QuoteDetailSearchFilter';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import NoResultContent from '../HomePageContent/NoResultContent';
import Constants from 'src/helper/Constants';
import ApprovedTabList from './QuoteDetailTab/ApprovedTabList';
import PendingTabList from './QuoteDetailTab/PendingTabList';
import NoBidTabList from './QuoteDetailTab/NoBidTabList';
import BookedTabList from './QuoteDetailTab/BookedTabList';
import { useQuoteStore } from 'src/hooks/quote';
import { useProductStore } from 'src/hooks/product';
import QuoteConfig from "@system/config/quote";
import { __remove, __set } from 'src/store/axios_indicator';
import Quote from "@system/config/quote";
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';

const c = System.getParams();

const QuoteDetailTabsListing = (props) => {
    const { QuoteTabList: { APR, BKD, PND, NBD } } = Constants
    const QuoteTabType = System.getParams().__c_QuoteDetailTabList || APR.param_value;
    const QuoteTabTypeName = QuoteTabType === APR.param_value ? 'Approved' : QuoteTabType === BKD.param_value ? 'Booked' : QuoteTabType === PND.param_value ? 'Pending' : QuoteTabType === NBD.param_value ? 'NoBid' : 'Expired'
    let defaultTabList = {
        APR: {
            name: APR.name,
            param_value: APR.param_value,
            count: 0
        },
        PND: {
            name: PND.name,
            param_value: PND.param_value,
            count: 0
        },
        NBD: {
            name: NBD.name,
            param_value: NBD.param_value,
            count: 0
        },
        BKD: {
            name: BKD.name,
            param_value: BKD.param_value,
            count: 0
        },
        // EXP: {
        //     name: EXP.name,
        //     param_value: EXP.param_value,
        //     count: 0
        // }
    };
    const [homeTabList, setHomeTabList] = useState(defaultTabList)
    const [__check] = useAxiosIndicatorCheck();
    const quoteNumber = c.quote_number;
    let [noResultForCheckout, setNoResultForCheckout] = useState(false);
    let [noResultForRFQ, setNoResultForRFQ] = useState(false);
    const [selectedTab, setSelectedTab] = useState()
    const [{  get_current_quote_cart, line_items }, { fetch_submitted_quote_list }, { add_multiple_quote }] = useQuoteStore();
    const [currentTabDetail, setCurrentTabDetail] = useState(line_items[QuoteTabTypeName])
    const [{ productList }, { }, { }] = useProductStore();
    const [{ pricing_list }, { }, { }] = useProductInventoryPriceStore();

    const quoteList = get_current_quote_cart();

    useEffect(() => {
      setSelectedTab(QuoteTabType !== undefined ? QuoteTabType : homeTabList.APR.param_value)
    }, [QuoteTabType])

    useEffect(() => {
        const fetchAPICall = async () => {
            __set('QUOTE_API_CALL');
           const res = await fetch_submitted_quote_list({
                "pageNumber": 1,
                "pageSize": 1,
                "sortBy": '',
                "sortType": "",
                "quoteNumber": quoteNumber
            })
            if (res?.payload?.records?.length === 0) {
                window.location.href = Quote.getSubmittedQuoteAbsoluteUrl()
            }
            __remove('QUOTE_API_CALL')
        };
        fetchAPICall();
    }, []);

    useEffect(() => {
        const temData = { ...homeTabList }
        temData.APR.count = line_items?.Approved?.count || 0
        temData.BKD.count = line_items?.Booked?.count || 0
        // temData.EXP.count = line_items?.Expired?.count || 0
        temData.NBD.count = line_items?.NoBid?.count || 0
        temData.PND.count = line_items?.Pending?.count || 0
        setCurrentTabDetail(line_items[QuoteTabTypeName])
        setHomeTabList(temData)
    }, [QuoteTabType, line_items])

    useEffect(() => {
        if (noResultForCheckout === true) {
            setNoResultForCheckout(false)
        }

    }, [quoteList]);

    const getActiveClass = (singleElement) => {
        if (homeTabList[selectedTab]?.param_value === singleElement.param_value) {
            return 'active'
        }
        return ''
    };

    const getTabLink = (singleElement) => {
        setSelectedTab(singleElement.param_value)
        return QuoteDetail.getQuoteDetailTabsListRouteURL({
            ...c,
            ['__c_QuoteDetailTabList']: singleElement.param_value
        });
    };

    const switchTab = async (url) => {
        history.pushState('', '', url);
    };

    const onRequestQuote = async () => {
        // let sessionQuoteList = get_current_quote_cart(currentQuote.quoteNumber);
        if (Object.entries(quoteList)?.length > 0) {
            __set('REQUEST_NEW_QUOTE')
            setNoResultForRFQ(false)
           const res = await add_multiple_quote({product: productList, quoteList: quoteList, pricing_list: pricing_list });
           if (res?.isSuccessFull) {
            window.location.href = QuoteConfig.getQuoteRouteURL();
             __remove('REQUEST_NEW_QUOTE')
           }

        } else {
            setNoResultForRFQ(true)
        }
    };

    return (
        <>
            <div className="submitted-quote-table mb-5">
                <QuoteDetailSearchFilter />
                {((currentTabDetail?.api_query_param === 'R' || currentTabDetail?.api_query_param === 'B') && noResultForRFQ === true) &&
                    <NoResultContent message={"No quote is selected. Please select a Quote to proceed"} isDisplay={false} />
                }

                <div className="d-flex justify-content-between align-items-end position-relative">
                    <div className="tabs-text-top d-flex align-items-start text-right position-absolute end-0 rnqbutton">
                        {((currentTabDetail?.api_query_param === 'R' || currentTabDetail?.api_query_param === 'B') && Object.keys(currentTabDetail?.records).length > 0) &&
                            <>
                                <button className="bs5 btn btn-primary ms-2 minw170"
                                    onClick={() => { onRequestQuote() }}
                                >
                                    {__check(['REQUEST_NEW_QUOTE']).status ? <i className="fa fa-spinner fa-spin" /> : 'Request New Quote'}
                                     </button>
                            </>
                        }
                        {currentTabDetail?.api_query_param === 'A' && (
                            <div className="bs5 pt-1 m-1 ms-auto">Booking and {' '}
                            <a href={Constants.PDFQuoteLink} target={"_blank"}
                                data-placement="bottom" data-toggle="tooltip"
                                data-html="true" rel="noreferrer"><i className="fa fa-info-circle me-2 text-black"
                                    aria-hidden="true" />
                                <span className="text-blue">Information</span></a>
                        </div>
                        )}
                    </div>
                    <div className="mobile-tab w-100">
                        <ul className="bs5 nav nav-tabs">
                            {Object.entries(homeTabList).map((v) => (
                                <React.Fragment key={v[1].name}>
                                    <li className={'bs5 nav-item'} key={v[1].name}>
                                        <a className={`'nav-link ' + ${getActiveClass(v[1])} ${v[1].count === 0 && 'disabled-link'}`}
                                            href={void (0)} onClick={async () => {
                                                await switchTab(getTabLink(v[1]), v[1])
                                            }}
                                        >
                                            <span>{v[1].name} ({v[1].count})</span>
                                        </a>
                                    </li>

                                </React.Fragment>
                            ))
                            }
                        </ul>
                    </div>

                </div>

                <div
                    id={homeTabList[selectedTab]?.param_value}>
                        {selectedTab === homeTabList.APR.param_value && <ApprovedTabList {...props} current_config={homeTabList[selectedTab]} />}
                        {selectedTab === homeTabList.PND.param_value && <PendingTabList {...props} current_config={homeTabList[selectedTab]}/>}
                        {selectedTab === homeTabList.NBD.param_value && <NoBidTabList {...props} current_config={homeTabList[selectedTab]}/>}
                        {selectedTab === homeTabList.BKD.param_value && <BookedTabList {...props} current_config={homeTabList[selectedTab]}/>}
                        {/* {selectedTab === homeTabList.EXP.param_value && <ExpiredTabList {...props} current_config={homeTabList[selectedTab]}/>} */}
                </div>
            </div>
        </>
    )
};

export default QuoteDetailTabsListing